/* eslint-disable react/no-unknown-property */
import { useRef } from 'react';
import { sendUserMessage } from '../xstate/app.xstate-utils';

const MAX_FILE_SIZE_BYTES = 4_194_304;

type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  'test-id'?: string;
};

export const useFileInput = (props: InputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;

    if (!files) return;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > MAX_FILE_SIZE_BYTES) {
        sendUserMessage({
          type: 'error',
          text: `File "${file.name}" exceeds the maximum size of 4MB (${(
            file.size /
            1024 /
            1024
          ).toFixed(2)} MB)`,
          autoClose: 3000,
        });

        if (inputRef.current) {
          inputRef.current.value = '';
        }
        return;
      }
    }

    props.onChange?.(e);
  };

  const input = (
    <input
      test-id={`${props['test-id']}-input`}
      ref={inputRef}
      {...props}
      onChange={handleChange}
    />
  );

  return { input, inputRef };
};
